import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PaymentMethod from "./Pages/PaymentMethod";
import UsagePayment from "./Pages/UsagePayment";
import { RiPriceTag3Line } from "react-icons/ri";
import PaymentInfo from "./Pages/PaymentInfo";
import InfoPaymentsModal from "./Pages/InfoPaymentsModal";
import { useLanguage } from "../Translations/LenguageContext";

const MainBilling = ({ account_id, fetchUserData }) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { bil_page } = useParams()
    const [showInfoPaymentModal, setShowInfoPaymentModal] = useState(false)

    const handleNavPage = (page) => {
        navigate(`/e8console/billing/${page}`)
    }

    useEffect(() => {
        const showMessage = localStorage.getItem("e8-show-payment-message")
        // if (showMessage) {
        //     showMessage == "true" ? setShowInfoPaymentModal(true) : setShowInfoPaymentModal(false)
        // } else {
        //     setShowInfoPaymentModal(true)
        // }
    }, [])

    return (
        <div className="main_billing_cont">
            <div className="main_billing_cont_inner">
                <div className="analytics_cont_header">
                    <div className="analytics_cont_header_title">
                        <p className="mainframe_item_title fade-in">{t.billing.title}</p>
                        <div className="analytics_cont_header_title_btn_cont">
                            {/* <button className="analytics_cont_header_title_btn fade-in"><RiPriceTag3Line/> Pricing</button> */}
                        </div>
                    </div>
                    <div className="navigation_btns_analytics">
                        <button className={`navigation_btns_analytics_btn fade-in ${bil_page == "wallet" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("wallet")}>{t.billing.wallet}</button>
                        <button className={`navigation_btns_analytics_btn fade-in ${bil_page == "usage" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("usage")}>{t.billing.usage}</button>
                        <button className={`navigation_btns_analytics_btn fade-in ${bil_page == "payment-info" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("payment-info")}>{t.billing.payment_info}</button>
                    </div>
                </div>

                <div className="main_billing_cont_inner_body">
                    {bil_page == "usage" && (
                        <UsagePayment account_id={account_id} />
                    )}

                    {bil_page == "wallet" && (
                        <PaymentMethod account_id={account_id} fetchUserData={fetchUserData}/>
                    )}

                    {bil_page == "payment-info" && (
                        <PaymentInfo account_id={account_id} />
                    )}

                </div>
            </div>

            <InfoPaymentsModal
                show={showInfoPaymentModal}
                handleClose={() => setShowInfoPaymentModal(false)}
            />

        </div>
    )
}

export default MainBilling